import styled from "styled-components";

import { colors } from "shared/ui/tokens";

export const Divider = styled.div`
    margin-top: 22px;
    padding-top: 18px;
    border-top: 1px solid ${colors.borderSofter};
`;

export const WeightRow = styled.div`
    display: flex;
    gap: 8px;

    & > *:first-child {
        flex: 1 1 60px;
        min-width: 0;
    }

    & > *:last-child {
        flex: 0 0 84px;
    }
`;

export const WeightBlock = styled.div`
    max-width: 240px;
    margin-bottom: 20px;
`;

export const NutritionLabel = styled.div`
    margin-bottom: 12px;
    font-size: 12px;
    color: ${colors.textSecondary};
`;

export const IikoRow = styled.div`
    display: flex;
    align-items: flex-end;
    gap: 8px;
    flex-wrap: wrap;
`;

export const IikoSelectWrap = styled.div`
    flex: 1 1 260px;
    min-width: 0;
`;

export const ConnectedBadge = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 24px;
    padding: 0 10px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 700;
    color: ${colors.success};
    background: rgba(76, 175, 80, 0.12);

    &::before {
        content: "";
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: ${colors.success};
    }
`;
